import resolveSchema from "./api";

export default resolveSchema;

export const getJson = path => ({
  method: "GET",
  endpoint: `${process.env.PUBLIC_URL}${path}`
});



// WEBPACK FOOTER //
// ./src/services/Api/local.js